import React from "react";
import PropTypes from "prop-types";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import slugify from "slugify";
import { amxPalette } from "../ThemeProvider";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      backgroundColor: amxPalette.white.main,
      "& > *": {
        borderColor: amxPalette.primaryBlue.main,
        color: amxPalette.primaryBlue.main,
        "&.Mui-selected": {
          color: amxPalette.white.main,
          backgroundColor: amxPalette.primaryBlue.main,
        },
        "&.Mui-selected:hover": {
          backgroundColor: amxPalette.primaryBlue.main,
        },
      },
      "&:hover": {
        backgroundColor: amxPalette.white.main,
      },
    },
    toggleButton: {
      fontSize: "1vw",
      padding: "1vw",
    },
  })
);

export const AmxToggleButtonGroup = (props) => {
  const { toggles, muiProps } = props;
  const classes = useStyles();

  return (
    <ToggleButtonGroup className={classes.root} {...muiProps}>
      {toggles.map((toggle) => (
        <ToggleButton
          key={toggle}
          value={slugify(toggle).toLowerCase()}
          color="primary"
          className={classes.toggleButton}
        >
          {toggle}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

AmxToggleButtonGroup.propTypes = {
  /**
   * An array of the Toggles you want to show, eg: ["Foo", "Bar"]
   */
  toggles: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * The props to be sent to the ToggleButtonGroup MUI component
   */
  muiProps: PropTypes.shape(ToggleButtonGroup.propTypes),
};
